import React from "react";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
// import "./About.css";



function History() {
  return (
    <div className="about-page">
      <Header />
      <header className="height-75">
        <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
          <h1 className="text-center fw-semibold">Terms & Conditions</h1>
        </div>
      </header>

      <div className="container my-5">
        <div className="row">
          <div className=" d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
            <h2 className="mb-4 mb-lg-5">Terms & Conditions</h2>
            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
          Please read these terms and conditions carefully before using Our Service.<br/>
              <h5>Acknowledgment</h5>

These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service.
Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service.
By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with any part of these Terms and Conditions then You may not access the Service.
You represent that you are over the age of 18. The Company does not permit those under 18 to use the Service.

            </p>
<h6>Termination</h6>
            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
              We may terminate or suspend Your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach these Terms and Conditions.
Upon termination, Your right to use the Service will cease immediately.

              <br /> <br />
              <h5>"AS IS" and "AS AVAILABLE" Disclaimer</h5>
The Service is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of its Affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the Service, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and makes no representation of any kind that the Service will meet Your requirements, achieve any intended results, be compatible or work with any other software, applications, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected.            </p>


<h6>Definitions</h6>
            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
              For the purposes of this Privacy Policy:<br/>
             <b>Account</b>  means a unique account created for You to access our Service or parts of our Service.<br/>
<b>Affiliate</b> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.<br/>
<b>Company</b> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to pandit ram kedar ram kishor.<br/>
<b>Cookies</b> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.<br/>
<b>Country</b> refers to: Uttar Pradesh, India

              <br /> <br />
             Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.
Personal Data is any information that relates to an identified or identifiable individual.
Service refers to the Website.
Service Provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.

            </p>
            
            

            

       
          </div>
          {/* <div className="col-lg-6 d-flex justify-content-center">
            <img
              src="./img/banner-acm.png"
              className="img-fluid h-25 w-100"
              alt=""
            />
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default History;
